import { Descriptions } from 'antd';
import React from 'react';
import { translations } from '../../../../config/translations';
import { Props } from './index';
import ToolMultimediaSection from './ToolMultimediaSection';

const ToolDetails: React.FC<Props> = ({ tool, canEditMultimedia, onToolUpdated }) => {
    return (
        <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label={translations.projects.name}>
                {tool.name}
            </Descriptions.Item>
            <Descriptions.Item label={translations.projects.description}>
                {tool.description}
            </Descriptions.Item>
            <Descriptions.Item label={translations.news.archived}>
                {tool.isArchived ? 'Da' : 'Ne'}
            </Descriptions.Item>
            <Descriptions.Item label={translations.tools.multimedia}>
                <ToolMultimediaSection
                    tool={tool}
                    canEdit={!!canEditMultimedia}
                    onToolUpdated={onToolUpdated}
                />
            </Descriptions.Item>
        </Descriptions>
    );
};

export default ToolDetails;

